import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gooper Semibold';
    src: url('/fonts/Gooper-Semibold.woff2') format('woff2'),
         url('/fonts/Gooper-Semibold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    font-family: ${theme.typography.body.fontFamily};
    font-weight: ${theme.typography.body.fontWeight};
    color: ${theme.colors.text};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.typography.heading.fontFamily};
    font-weight: ${theme.typography.heading.fontWeight};
    color: ${theme.colors.text};
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button:not([class]) {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
  }
`;

export default GlobalStyles; 